import cn from 'classnames';
import { useCommon } from 'contexts/common';
import { Product } from 'interfaces/product';
import { CollectionProduct } from 'models/collection/collection';
import { StaticPDPProduct } from 'modules/product-details/types';
import React from 'react';
import hasPersonalizedDiscount from 'utils/has-personalized-discount';
interface PropTypes {
  className?: string;
  title?: string;
  color?: string;
  product?: CollectionProduct | StaticPDPProduct | Product;
  subTitle?: string;
}
/**
 * Component, linked to a product, which visually highlights certain features of the product, such as whether the product is new or on sale.
 */
const Ribbon: React.FC<PropTypes> = ({ className, title, color, subTitle, product }) => {
  const { globalDiscount } = useCommon();
  const hasDiscount = product ? hasPersonalizedDiscount(product, globalDiscount) : false;

  const ribbonClasses =
    color === 'Red-Sale'
      ? 'bg-badge-discount text-text-dark-bg-contrast-white'
      : 'bg-grey-100 text-text-primary';

  if (!title && !subTitle) return null;

  return (
    <div
      className={cn(
        'inline-block rounded-full px-1.5 py-0.5 text-xs font-normal',
        ribbonClasses,
        className
      )}
    >
      {<span>{hasDiscount ? `>-${globalDiscount.discount?.amountInPercent}%` : title}</span>}
      {subTitle && !hasDiscount && <div>{subTitle}</div>}
    </div>
  );
};

export default Ribbon;
